import React from 'react';
import '../styles/carousel.scss'

import Slider from 'infinite-react-carousel';
import slideImg1 from '../assets/slide-img-1.png'
import slideImg2 from '../assets/slide-img-2.png'
import slideImg3 from '../assets/slide-img-3.png'
import next from '../assets/next.svg'
import back from '../assets/back.svg'

class CustomSlider extends React.Component {
    render() {
        const settings = {
            arrows: true,
            arrowsBlock: true,
            autoplay: true,
            autoplaySpeed: 4000,
            centerPadding: 0,
            className: 'carousel-slider',
            slidesPerRow: 1,
            dots: true,
            wheel: false,
            fade: true,
            swipe: false,
            prevArrow: <img src={back} alt="back-arrow" className="arrow" />,
            nextArrow: <img src={next} alt="next-arrow" className="arrow" />,

        };
        return (
            <div>
                <Slider {...settings}>
                    <div className="slide">
                        <div className="slide-1">
                            <div className="left-side">
                                <h1>Clean. Chic. <span className="red-text">Creative.</span></h1>
                                <h3>At Creative Nails, we have a skillful group of nail artists that can supply an endless amount of nail design services and are able to please even the most demanding customers.</h3>
                            </div>
                            <div className='right-side'>
                                <img src={slideImg1} />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className="slides slide-2">
                            <div className="left-side">
                                <h1>Adding Care to Your <span className="red-text">Nail</span></h1>
                                <h3>We give our best service to each customer and are dedicated to bring you the best nail care services within the nail salon industry. We only use the best quality products and stock only high-end name brands.</h3>
                            </div>
                            <div className='right-side'>
                                <img src={slideImg3} />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className="slides slide-3">
                            <div className="left-side">
                                <h1>Creating <span className="red-text">Beautiful</span> Designs</h1>
                                <h3>Our nail salon brings a unique and personalize nail designs to all clients in the Summerville area. We are a group of nail artists trained to accomplish any sort of nail care.</h3>
                            </div>
                            <div className='right-side'>
                                <img src={slideImg2} />
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>
        );
    }
}

export default CustomSlider
